import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useState, useRef } from 'react';
import postal from 'postal';

function createCheckedClass(disabled: boolean) {
  const dark = false;
  if (disabled) {
    return dark ? 'e-ifms-checkbox-disabled-dark' : 'e-ifms-checkbox-disabled';
  } else {
    return 'e-ifms-checkbox';
  }
}

function createUncheckedClass(disabled: boolean) {
  const dark = false;

  if (disabled) {
    return dark ? 'e-ifms-checkbox-unchecked-disabled-dark' : 'e-ifms-checkbox-unchecked-disabled';
  } else {
    return 'e-ifms-checkbox-unchecked';
  }
}

const createChekedCustomStyles = (disabled: boolean, focus: boolean): React.CSSProperties | undefined => !focus ? undefined : {
  border: '1px dotted', width: "14px", height: "14px"
};

const Checked = ({ disabled, focus }: { disabled: boolean, focus: boolean }) => (
  <svg className={createCheckedClass(disabled)} xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" style={createChekedCustomStyles(disabled, focus)}
    viewBox="0 0 24 24">
    {disabled
      ? <path
        d="M 10.041 17 l -4.5 -4.319 l 2.212 -1.983 l 3.08 2.937 l 7.021 -7.183 l 1.994 2.177 l -8.991 9.111 z m -5.041 -15 c -1.654 0 -3 1.346 -3 3 v 14 c 0 1.654 1.346 3 3 3 h 14 c 1.654 0 3 -1.346 3 -3 v -14 c 0 -1.654 -1.346 -3 -3 -3 h -14 z m 19 3 v 14 c 0 2.761 -2.238 5 -5 5 h -14 c -2.762 0 -5 -2.239 -5 -5 v -14 c 0 -2.761 2.238 -5 5 -5 h 14 c 2.762 0 5 2.239 5 5 z" />
      : <path
        d="M 10.041 17 l -4.5 -4.319 l 2.212 -1.983 l 3.08 2.937 l 7.021 -7.183 l 1.994 2.177 l -8.991 9.111 z m -5.041 -15 c -1.654 0 -3 1.346 -3 3 v 14 c 0 1.654 1.346 3 3 3 h 14 c 1.654 0 3 -1.346 3 -3 v -14 c 0 -1.654 -1.346 -3 -3 -3 h -14 z m 19 3 v 14 c 0 2.761 -2.238 5 -5 5 h -14 c -2.762 0 -5 -2.239 -5 -5 v -14 c 0 -2.761 2.238 -5 5 -5 h 14 c 2.762 0 5 2.239 5 5 z" />
    }
  </svg>
);

const createUncheckedCustomStyles = (disabled: boolean, focus: boolean): React.CSSProperties | undefined => !focus ? undefined : {
  border: '1px dotted', width: "14px", height: "14px"
};

const Unchecked = ({ disabled, focus }: { disabled: boolean, focus: boolean }) => (
  <svg className={createUncheckedClass(disabled)} xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"
    viewBox="0 0 24 24" style={createUncheckedCustomStyles(disabled, focus)}>
    <path
      d="M5 2c-1.654 0-3 1.346-3 3v14c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3v-14c0-1.654-1.346-3-3-3h-14zm19 3v14c0 2.761-2.238 5-5 5h-14c-2.762 0-5-2.239-5-5v-14c0-2.761 2.238-5 5-5h14c2.762 0 5 2.239 5 5z" />
  </svg>
);

// const Checked = ({ disabled, focus }:{ disabled:boolean, focus:boolean}) => (
//   <svg className={createCheckedClass(disabled)} xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" style={{border: (!disabled && focus) ? '1px dashed #bababa' : 'none'}}>
//     {disabled
//       ? <path stroke="gray" d="M10.041 17l-4.5-4.319 1.395-1.435 3.08 2.937 7.021-7.183 1.422 1.409-8.418 8.591zm-5.041-15c-1.654 0-3 1.346-3 3v14c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3v-14c0-1.654-1.346-3-3-3h-14zm19 3v14c0 2.761-2.238 5-5 5h-14c-2.762 0-5-2.239-5-5v-14c0-2.761 2.238-5 5-5h14c2.762 0 5 2.239 5 5z"/>
//       : <path stroke="black" d="M 5 2 c -1.654 0 -3 1.346 -3 3 v 14 c 0 1.654 1.346 3 3 3 h 14 c 1.654 0 3 -1.346 3 -3 v -14 c 0 -1.654 -1.346 -3 -3 -3 h -14 z m 19 3 v 14 c 0 2.761 -2.238 5 -5 5 h -14 c -2.762 0 -5 -2.239 -5 -5 v -14 c 0 -2.761 2.238 -5 5 -5 h 14 c 2.762 0 5 2.239 5 5 m-13.9 12l-4.5-4.319 1.395-1.435 3.08 2.937 7.021-7.183 1.422 1.409-8.418 8.591"/>
//     }
//   </svg>
// );

// const createUncheckedCustomStyles = (disabled:boolean, focus:boolean):React.CSSProperties|undefined => disabled ? undefined : {background: 'transparent', border: (!disabled && focus) ? '1px dashed #bababa' : 'none'};

// const Unchecked = ({ disabled, focus }:{ disabled:boolean, focus:boolean}) => (
//   <svg className={createUncheckedClass(disabled)} xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" style={createUncheckedCustomStyles(disabled, focus)}>
//     <path d="M5 2c-1.654 0-3 1.346-3 3v14c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3v-14c0-1.654-1.346-3-3-3h-14zm19 3v14c0 2.761-2.238 5-5 5h-14c-2.762 0-5-2.239-5-5v-14c0-2.761 2.238-5 5-5h14c2.762 0 5 2.239 5 5z"/>
//   </svg>
// );

function CheckboxUncontrolled({
  initialValue,
  onChange = () => { },
  onTabNext = undefined,
  onTabPrevious = undefined,
  focusId = undefined,
  disabled = false,
  allowOnChange = undefined,
  name = undefined,
  ...other
}: {
  initialValue: boolean,
  onChange: (x: boolean) => void,
  onTabNext?: (() => boolean) | undefined,
  onTabPrevious?: (() => boolean) | undefined,
  focusId?: string | undefined,
  disabled?: boolean,
  name?: string | undefined,
  allowOnChange?: ((e?: React.MouseEvent) => Promise<boolean> | boolean) | undefined,
}) {
  const [focus, setFocus] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const [value, setValue] = useState(initialValue);

  const inputId = !!focusId ? focusId : _.uniqueId('ifms-checkbox-');

  let valueChangeExternallySubscription = useRef<ISubscriptionDefinition<any> | null>(null);

  useEffect(() => {
    subscribeChannels();

    return unsubscribeChannels;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if(initialValue !== value) {
      setValue(initialValue);
    }
  }, [initialValue]);

  function subscribeChannels() {
    valueChangeExternallySubscription.current = postal.subscribe({
      channel: 'ifms',
      topic: 'ifms.chk-uncontrolled',
      callback: ({ id, value }: { id: string, value: boolean }) => {
        if (id === inputId) {
          setValue(value);
        }
      },
    });
  }

  function unsubscribeChannels() {
    if (valueChangeExternallySubscription.current) {
      postal.unsubscribe(valueChangeExternallySubscription.current);
    }
  }

  async function handleClick(e?: React.MouseEvent) {
    if (!disabled) {
      if (!allowOnChange || (await allowOnChange(e))) {
        const newValue = !value;
        onChange(newValue);
        setValue(newValue);
      }
    }
  }

  function processTabNext(e: React.KeyboardEvent<HTMLInputElement>) {
    if (onTabNext) {
      const tabProcessed = onTabNext();
      if (tabProcessed) {
        e.preventDefault();
        return;
      }
    }
  }

  function processTabPrevious(e: React.KeyboardEvent<HTMLInputElement>) {
    if (onTabPrevious) {
      const tabProcessed = onTabPrevious();
      if (tabProcessed) {
        e.preventDefault();
        return;
      }
    }
  }

  function onKeyDown(e: React.KeyboardEvent<HTMLInputElement>) {

    const tab = 9;
    const space = 32;

    if (e.keyCode === tab) {
      if (e.shiftKey) {
        processTabPrevious(e);
      } else {
        processTabNext(e);
      }
    }
    else if (e.keyCode === space) {
      handleClick();
    }
  }

  let containerStatus = 'e-ifms-checkbox-container ifms-tabable';

  return (
    <div
      className={containerStatus}
      onClick={(e) => { handleClick(e) }}
      {...other}
      onFocus={() => {
        setFocus(true);
      }}
      onBlur={() => {
        setFocus(false);
      }}
    >
      <input
        id={inputId}
        name={name}
        ref={inputRef}
        type="text"
        className="ifms-tabable ifms-tabable-active"
        style={{ width: '1px', height: '1px', position: 'absolute', opacity: '0', cursor: 'pointer' }}
        onKeyDown={onKeyDown}
      />
      {value ? <Checked disabled={disabled} focus={focus} /> : <Unchecked disabled={disabled} focus={focus} />}
    </div>
  );
}

CheckboxUncontrolled.defaultProps = {
  onChange: () => { },
  initialValue: false,
  disabled: false,
};

CheckboxUncontrolled.propTypes = {
  onChange: PropTypes.func.isRequired,
  initialValue: PropTypes.bool.isRequired,
  onTabNext: PropTypes.func,
  onTabPrevious: PropTypes.func,
  focusId: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
};


export default React.memo(CheckboxUncontrolled);

